<template>
  <VueDialog :dialog-data="dialogData" class="table-column-set" @confirm="confirm">
    <el-row type="flex" align="middle">
      <el-checkbox class="indeterminate" :indeterminate="isIndeterminate" v-model="checkAll" @change="selectAll">全选</el-checkbox>
      <el-button type="text" class="black indeterminate-btn" @click="inverseSelect">反选</el-button>
      <el-button type="text" class="black indeterminate-btn" @click="recommend">推荐</el-button>
    </el-row>
    <el-divider></el-divider>
    <el-checkbox-group v-model="checkedList" @change="change">
      <template v-for="(item, index) in list">
        <el-checkbox :key="index" :label="item.property" :title="item.label">
          {{item.label}}
        </el-checkbox>
      </template>
    </el-checkbox-group>
  </VueDialog>
</template>

<script>
export default {
  name: "TableColumnSet",
  props: {dialogData: Object},
  data() {
    return {
      checkedList: [],
      oldCheckedList: [],
      isIndeterminate: false,
      checkAll: false,
      list: this.dialogData.columnList
    }
  },
  methods: {
    selectAll(val) {
      this.checkedList = val ? this.list.map(item => item.property) : [];
      this.change(this.checkedList)
    },
    inverseSelect() {
      this.checkedList = this.list.filter(item => !this.checkedList.includes(item.property)).map(item => item.property);
      this.change(this.checkedList)
    },
    recommend() {
      this.checkedList = this.list.filter(item => !item.defaultHide).map(item => item.property);
      this.change(this.checkedList)
    },
    change(val) {
      let checkedCount = val.length;
      this.checkAll = checkedCount === this.list.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.list.length;
    },
    confirm() {
      localStorage.setItem(this.dialogData.api, JSON.stringify(this.checkedList));
      this.$emit("finish");
      this.dialogData.visible = false;
    }
  },
  created() {
    this.checkedList = [...this.dialogData.checkedList];
    this.oldCheckedList = [...this.dialogData.checkedList];
    this.change(this.checkedList)
  }
}
</script>

<style scoped lang="scss">
.table-column-set {
  .el-divider--horizontal {
    margin: 10px 0;
  }
  .indeterminate {
    height: 19px;
    /deep/ {
      .el-checkbox__label {
        line-height: normal;
      }
    }
  }
  .indeterminate-btn {
    font-size: 14px;
    margin-left: 20px;
    line-height: normal;
    border: none
  }
  .el-checkbox-group {
    /deep/ {
      .el-checkbox {
        line-height: 30px;
        text-align: left;
        .el-checkbox__input {
          font-size: 0;
        }
        .el-checkbox__label {
          width: 150px;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          vertical-align: middle;
        }
      }
    }
  }
}
</style>
